import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";

export const MobileNavBarTabs = ({ handleClick }) => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="mobile-nav-bar__tabs">
      <MobileNavBarTab
        path="/leaderboard"
        label="Leaderboard"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/auction-list"
        label="Auction List"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/auction-results"
        label="Auction Results"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/rules"
        label="Rules"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/statistics"
        label="Statistics"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/profile"
        label="Profile"
        handleClick={handleClick}
      />
      {isAuthenticated && (
        <>
          <MobileNavBarTab
            path="/transfers"
            label="Transfers"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/loans"
            label="Loans"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/score-breakdown"
            label="Score Breakdown"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin"
            label="Admin"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin/site-vars"
            label="Site Variables"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin/update-week"
            label="Update Week"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin/team-admin"
            label="Team Admin"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin/scraper"
            label="Scraper"
            handleClick={handleClick}
          />
        </>
      )}
    </div>
  );
};
